import React, { Component, Fragment } from "react";
import {
	Button,
	Modal,
	Form,
	Input,
	Row,
	Icon,
	Spin,
	InputNumber,
	Select,
	Checkbox,
	message
} from "antd";
import { inject, observer } from "mobx-react";
import co from "co";
import { Guides } from "common/guides";

import { 	testEmail, delay } from "services/api";

const FormItem = Form.Item;
const Option = Select.Option;

const tailFormItemLayout = {
	wrapperCol: {
		xs: {
			span: 24,
			offset: 0
		},
		sm: {
			span: 18,
			offset: 6
		}
	}
};

@Form.create({
	// mapPropsToFields(props) {
	// 	return props.fields;
	// }
})
@observer
class AddEditEmailForm extends Component {
	validateForm = callback => {
		this.props.form.validateFieldsAndScroll( {force: true }, callback);
	};

	getValues = () => {
		return {
			address: this.props.form.getFieldValue("address"),
			login: this.props.form.getFieldValue("login"),
			password: this.props.form.getFieldValue("password"),
			server: this.props.form.getFieldValue("server"),
			port: this.props.form.getFieldValue("port"),
			protocol: this.props.form.getFieldValue("protocol"),
			ssl: this.props.form.getFieldValue("ssl"),
			checkSpamFolder: this.props.form.getFieldValue("checkSpamFolder"),
			spamFolderName: this.props.form.getFieldValue("spamFolderName")
		};
	};

	spamFolderValidator = (rule, value, callback) => {
		// console.log("Validating", value);
		// if (value == null || value == undefined) {
		// 	callback("Required");
		// }
		let protocol = this.props.form.getFieldValue("protocol");
		if (protocol == "imap") {
			let checkSpamFolder = this.props.form.getFieldValue(`checkSpamFolder`);
			if (checkSpamFolder) {
				if (!value) {
					callback("Spam folder name is required");
				}
			}
		}
		callback();		
	};

	render() {
		const formItemLayout = {
			labelCol: {
				xs: { span: 24 },
				sm: { span: 6 }
			},
			wrapperCol: {
				xs: { span: 24 },
				sm: { span: 18 }
			}
		};

		let protocol = this.props.form.getFieldValue("protocol");
		let spamFolderDisplay = "none";
		if (protocol == "imap") {
			spamFolderDisplay = "block";
		} else {
			spamFolderDisplay = "none";
		}

		return (
			<Form>
				<FormItem
					label="Email Address"
					{...formItemLayout}
					help={
						<Fragment>
							Enter your email address (can be in spintax and have
							tags){' '}
							<a href={Guides["catchall-mail"]} target="_blank">
								<Icon type="question-circle" theme="twoTone" />
							</a>
						</Fragment>
					}
				>
					{this.props.form.getFieldDecorator("address", {
						rules: [
							{
								required: true,
								message: "Please enter your email address"
							}
						]
					})(<Input type="email" />)}
				</FormItem>
				<FormItem
					label="Email Login"
					{...formItemLayout}
					extra="Enter your email login"
				>
					{this.props.form.getFieldDecorator("login", {
						rules: [
							{
								required: true,
								message: "Please enter your email login"
							}
						]
					})(<Input type="email" />)}
				</FormItem>
				<FormItem label="Password" {...formItemLayout}>
					{this.props.form.getFieldDecorator("password", {
						rules: [
							{
								required: true,
								message: "Email password is required"
							}
						]
					})(<Input type="password" />)}
				</FormItem>
				<FormItem label="Server Address" {...formItemLayout}>
					{this.props.form.getFieldDecorator("server", {
						rules: [
							{
								required: true,
								message: "Please enter server address"
							}
						]
					})(<Input type="text" />)}
				</FormItem>
				<FormItem label="Server Port" {...formItemLayout}>
					{this.props.form.getFieldDecorator("port", {
						rules: [
							{
								required: true,
								message: "Please enter the server port"
							}
						]
					})(<InputNumber />)}
				</FormItem>
				<FormItem
					label="Server Type"
					{...formItemLayout}
					help="Email Server Type"
				>
					{this.props.form.getFieldDecorator("protocol", {
						rules: [
							{
								required: true,
								message: "Please select email protocol"
							}
						]
					})(
						<Select
							style={{ width: 200 }}
							placeholder="Select email protocol"
						>
							<Option value="pop3">POP3</Option>
							<Option value="imap">IMAP</Option>
						</Select>
					)}
				</FormItem>
				<FormItem {...tailFormItemLayout} style={{ marginBottom: 0 }}>
					{this.props.form.getFieldDecorator("ssl", {
						valuePropName: "checked",
						initialValue: true
						// rules: [
						// 	{
						// 		required: true,
						// 		message: "Use SSL or not"
						// 	}
						// ]
					})(<Checkbox>Use SSL</Checkbox>)}
				</FormItem>
				<FormItem {...tailFormItemLayout} style={{ marginBottom: 0, display: spamFolderDisplay }}>					
					<FormItem style={{ display: 'inline-block'}}>
						{this.props.form.getFieldDecorator("checkSpamFolder", {
							valuePropName: "checked",
							initialValue: false
							// rules: [
							// 	{
							// 		required: true,
							// 		message: "Use SSL or not"
							// 	}
							// ]
						})(<Checkbox>Check Spam Folder</Checkbox>)}
					</FormItem>
					<FormItem colon={false} label="Folder" {...formItemLayout} style={{ display: 'inline-block'}}>
						{this.props.form.getFieldDecorator("spamFolderName", {
							rules: [
								{
									validator: this.spamFolderValidator,
									message: "Spam folder name is required"
								}
							]
						})(<Input type="text" />)}
					</FormItem>
				</FormItem>				
			</Form>
		);
	}
}

@inject("rootStore")
@observer
class AddEditEmailDialog extends Component {
	constructor(props) {
		super(props);
		this.state = {
			testingEmail: false
		};
	}

	mapPropsToFields = () => {
		return {};
	};

	validateForm = () => {
		return new Promise(resolve => {
			this.internalForm.validateForm((err, vals) => {
				resolve(err);
			});
		});
	};

	addEmail = () => {
		const {
			rootStore: { emailStore }
		} = this.props;
		co(
			function*() {
				const response = yield this.validateForm();
				if (response != null) {
					return;
				}
				emailStore.remoteAddEmail(this.internalForm.getValues());
			}.bind(this)
		);
	};

	testEmail = () => {
		co(
			function*() {
				const validateResponse = yield this.validateForm();
				if (validateResponse != null) {
					return;
				}
				const tmpEmailSettings = this.internalForm.getValues();

				const emailSettings = {
					emailAddress: tmpEmailSettings.address,
					emailLogin: tmpEmailSettings.login,
					emailPassword: tmpEmailSettings.password,
					emailServer: tmpEmailSettings.server,
					emailServerPort: tmpEmailSettings.port,
					mailProtocol: tmpEmailSettings.protocol,
					SSL: tmpEmailSettings.ssl,
					checkSpamFolder: tmpEmailSettings.checkSpamFolder,
					spamFolderName: tmpEmailSettings.spamFolderName
				};

				this.setState({
					testingEmail: true
				});
							
				const response = yield testEmail(emailSettings);

				this.setState({
					testingEmail: false
				});

				if (!response) {
					message.error(
						"Failed to login to the email. Unknown error"
					);
					return;
				}

				if (response.error) {
					message.error(response.error.message);
					return;
				}

				message.success("Successfully logged in to the email address");
			}.bind(this)
		);
	};

	hideDialog = () => {
		const {
			rootStore: { emailStore }
		} = this.props;

		emailStore.hideAddEmailDialog();
	};

	render() {
		const {
			rootStore: { emailStore }
		} = this.props;

		const ui = emailStore.ui;

		let title = "Add Email";

		const spinning =
			ui.addingEmail == true || this.state.testingEmail == true;

		return (
			<Modal
				style={{ top: 20 }}
				bodyStyle={{ paddingBottom: 5 }}
				visible={ui.addEmailDialogVisible}
				title={title}
				okText="Save"
				destroyOnClose={true}
				onCancel={this.hideDialog}
				onOk={this.addEmail}
				width={720}
				footer={[
					<Button key="cancel" onClick={this.hideDialog}>
						Cancel
					</Button>,
					<Button key="save" type="primary" onClick={this.addEmail}>
						Save
					</Button>,
					<Button key="test" onClick={this.testEmail}>
						Test
					</Button>
				]}
			>
				<Spin spinning={spinning}>
					<AddEditEmailForm
						fields={this.mapPropsToFields()}
						wrappedComponentRef={internalForm => {
							this.internalForm = internalForm;
						}}
					/>
				</Spin>
			</Modal>
		);
	}
}

export default AddEditEmailDialog;
